define("shared/helpers/word-initials", ["exports", "@ember/component/helper", "@ember/utils"], function (_exports, _helper, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/utils"eaimeta@70e063a35619d71f

  var _default = (0, _helper.helper)((_ref
  /*, hash*/
  ) => {
    let [title] = _ref;

    if ((0, _utils.isEmpty)(title)) {
      return '';
    }

    const words = title.split(' ').slice(0, 2);
    const initials = words.map(word => word.charAt(0).toUpperCase());
    return initials.join('');
  });

  _exports.default = _default;
});